import React from 'react'
import PropTypes from 'prop-types'

import { Card, Grid, Icon } from 'semantic-ui-react'
import { Link } from 'react-router'
import { compose } from 'recompose'

import Container from './RugDetailModuleContainer'
import Enhancer from './RugDetailModuleEnhancer'
import StandardError from 'Components/StandardError'
import StandardLoader from 'Components/StandardLoader'

import PageHeaderRow from 'Components/PageHeaderRow'
import Permissions from 'Components/Permissions'
import PictureCard from 'Components/PictureCard'
import PreviewModalPicture from 'Components/PreviewModal/PreviewModalPicture'
import ReservationsCard from 'Components/ReservationsCard'
import RugCardDetailed from 'Components/RugCardDetailed'

import * as styles from './styles'
import { hasPermission } from 'Components/Permissions/utils'

const RugDetailModule = props => {
  const {
    currentIndex,
    currentPicture,
    location,
    nextPicture,
    pictureError,
    picturePending,
    pictures,
    previewExpanded,
    previewOpen,
    previousPicture,
    rug,
    setCurrentIndex,
    setPrimary,
    showEditReservationModal,
    togglePreview,
    togglePreviewExpansion,
    uploadDesignerPicture,
    user,
    userPermissions,
  } = props

  const { fromPage } = location.query

  const mappedPictures = pictures.map((p, i) => (
    <PictureCard
      error={pictureError === p.id}
      index={i}
      key={p.id}
      pending={picturePending === p.id}
      picture={p}
      rug={rug}
      setCurrentIndex={setCurrentIndex}
      setPrimary={setPrimary}
      togglePreview={togglePreview}
      uploadDesignerPicture={uploadDesignerPicture}
      user={user}
    />
  ))

  const isAllowedToEditReservation = hasPermission('rug.action.editReserve', userPermissions)
  return (
    <Grid>
      <Grid.Row />
      <PageHeaderRow title="Details">
        <Link to={fromPage ? `/${fromPage}` : '/'} style={styles.link}>
          <Icon name="arrow left" />
          Back to Search
        </Link>
      </PageHeaderRow>

      <Grid.Row>
        <Grid.Column width={4}>
          <RugCardDetailed />

          <br />

          <Permissions
            permissions="rug.field.reservations"
            render={() => (
              <ReservationsCard
                isEditable={isAllowedToEditReservation}
                reservations={rug.reservations}
                showEditReservationModal={showEditReservationModal}
              />
            )}
          />
        </Grid.Column>

        <Grid.Column width={12}>
          <Card.Group itemsPerRow={4} stackable>
            {mappedPictures}
          </Card.Group>
        </Grid.Column>
      </Grid.Row>

      {previewOpen && (
        <PreviewModalPicture
          currentIndex={currentIndex}
          currentPicture={currentPicture}
          expanded={previewExpanded}
          next={nextPicture}
          open={previewOpen}
          previous={previousPicture}
          setCurrentIndex={setCurrentIndex}
          toggle={togglePreview}
          toggleExpansion={togglePreviewExpansion}
          disableRugInformation
        />
      )}
    </Grid>
  )
}

RugDetailModule.propTypes = {
  currentIndex: PropTypes.number.isRequired,
  currentPicture: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  nextPicture: PropTypes.bool.isRequired,
  pictureError: PropTypes.number.isRequired,
  picturePending: PropTypes.number.isRequired,
  pictures: PropTypes.array.isRequired,
  previewExpanded: PropTypes.bool.isRequired,
  previewOpen: PropTypes.bool.isRequired,
  previousPicture: PropTypes.bool.isRequired,
  rug: PropTypes.object.isRequired,
  setCurrentIndex: PropTypes.func.isRequired,
  setPrimary: PropTypes.func.isRequired,
  showEditReservationModal: PropTypes.func.isRequired,
  togglePreview: PropTypes.func.isRequired,
  togglePreviewExpansion: PropTypes.func.isRequired,
  uploadDesignerPicture: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  userPermissions: PropTypes.array.isRequired,
}

const composed = compose(
  Enhancer,
  Container,
  StandardLoader('Bringing in marked rugs…'),
  StandardError,
)

export default composed(RugDetailModule)
